let NextHandle = 1;
/**
 * Create a new runtime animation handle
 *
 * This function generates a unique handle for each animation.
 * The handle is a number that can be used to identify the animation in the runtime.
 *
 * @returns A unique runtime animation handle
 */
export function CreateMmdRuntimeAnimationHandle() {
    const handle = NextHandle;
    NextHandle += 1;
    return handle;
}
